import { render, staticRenderFns } from "./InstructorSkillIcons.vue?vue&type=template&id=631c47e2&scoped=true&"
import script from "./InstructorSkillIcons.vue?vue&type=script&lang=ts&"
export * from "./InstructorSkillIcons.vue?vue&type=script&lang=ts&"
import style0 from "./InstructorSkillIcons.vue?vue&type=style&index=0&id=631c47e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631c47e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
